(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/right-bottom-buttons.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/right-bottom-buttons.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Button = svs.ui.ReactButton;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.page_play.jotai.atoms,
  randomLocationTriggerAtom = _svs$lyckoplatsen$com.randomLocationTriggerAtom,
  isRandomizingLocationAtom = _svs$lyckoplatsen$com.isRandomizingLocationAtom;
const _jotai = jotai,
  useSetAtom = _jotai.useSetAtom,
  useAtomValue = _jotai.useAtomValue;
const isSelfService = svs.core.config.data.svsconfig.isSelfService;
const _svs$lyckoplatsen$com2 = svs.lyckoplatsen.components.page_play.react.hooks,
  useGeolocation = _svs$lyckoplatsen$com2.useGeolocation,
  useHomeLocation = _svs$lyckoplatsen$com2.useHomeLocation,
  useHomeLocationSelfService = _svs$lyckoplatsen$com2.useHomeLocationSelfService;
const CONSTANTS = svs.lyckoplatsen.components.shared_constants.CONSTANTS;
const _React = React,
  useState = _React.useState;
const RightBottomButtons = () => {
  const handleGeolocation = useGeolocation();
  const handleHomeLocation = useHomeLocation();
  const handleHomeLocationSelfService = useHomeLocationSelfService();
  const setRandomLocationTrigger = useSetAtom(randomLocationTriggerAtom);
  const isRandomizingLocation = useAtomValue(isRandomizingLocationAtom);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isGeolocationInProgress = _useState2[0],
    setIsGeolocationInProgress = _useState2[1];
  const handleHomeLocationClick = () => {
    svs.components.analytics.trackEvent({
      category: 'Lyckoplatsen',
      action: 'Sök',
      opt_label: CONSTANTS.LOCATION_TYPES.HOME
    });
    if (isSelfService) {
      handleHomeLocationSelfService();
    } else {
      handleHomeLocation();
    }
  };
  const handleSlumpaClick = () => {
    if (isRandomizingLocation) {
      return;
    }
    svs.components.analytics.trackEvent({
      category: 'Lyckoplatsen',
      action: 'Slumpa',
      opt_label: 'kartvy_ikon'
    });
    setRandomLocationTrigger(count => count + 1);
  };
  const handleGeolocationClick = () => {
    if (isGeolocationInProgress) {
      return;
    }
    setIsGeolocationInProgress(true);
    svs.components.analytics.trackEvent({
      category: 'Lyckoplatsen',
      action: 'Sök',
      opt_label: CONSTANTS.LOCATION_TYPES.CURRENT
    });
    handleGeolocation();
    setTimeout(() => setIsGeolocationInProgress(false), 4000);
  };
  return React.createElement("div", {
    className: "lp-right-bottom-buttons"
  }, React.createElement("div", {
    className: "animated-body"
  }, React.createElement(Button, {
    className: "lp-btn-slumpa lp-btn ".concat(isRandomizingLocation ? 'lp-btn-busy' : ''),
    onClick: handleSlumpaClick
  }, React.createElement("img", {
    src: "".concat(svs.core.config.data.svsconfig.cdn, "/images/lyckoplatsen/slumpa.svg"),
    alt: ""
  })), React.createElement(Button, {
    className: "lp-btn-home lp-btn",
    onClick: handleHomeLocationClick
  }, React.createElement("img", {
    src: "".concat(svs.core.config.data.svsconfig.cdn, "/images/lyckoplatsen/hemma.svg"),
    alt: ""
  })), !isSelfService && React.createElement(Button, {
    "data-testid": "position",
    className: "lp-btn-my-position lp-btn ",
    onClick: () => handleGeolocationClick()
  }, React.createElement("img", {
    src: "".concat(svs.core.config.data.svsconfig.cdn, "/images/lyckoplatsen/my-position.svg"),
    alt: ""
  }))));
};
Object.assign(svs.lyckoplatsen.components.page_play.react.components, {
  RightBottomButtons
});

 })(window);